<template>
    <div class="resetPassword container h-100">
        <div class="content">
            <h2 style="color:red;text-align:left;">重置密码</h2>
            <el-form :model="userForm" class="userForm" ref="userForm" :rules="rules"  label-width="100px" style="text-align:left;padding:0 120px;">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="邮箱" >
                            <el-input v-model="userForm.email" placeholder="请输入邮箱" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row >
                    <el-col :span="8">
                        <el-form-item label="新密码" prop="password">
                            <el-input v-model="userForm.password" placeholder="请输入新密码" show-password></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row >
                    <el-col :span="8">
                        <el-form-item label="确认密码" prop="confirmPass">
                            <el-input v-model="userForm.confirmPass" placeholder="请输入确认密码" show-password></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="margin-top:40px;">
                    <el-col :span="8" style="text-align:center;">
                        <el-button type="primary" @click="confirmAdd('userForm')">重置密码</el-button>
                    </el-col>
                </el-row >
            </el-form>
        </div>
    </div>
</template>

<script>
import {updatePassword} from '@/api/user'

export default {
    name:'resetPassword',
    data() {
        return {
            userForm:{
                email: '',
                password: '',
                confirmPass: '',
                id:''
            },
            rules:{
                password:[
                    { required: true, message:'密码不能为空', trigger: 'blur'},
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                confirmPass: [
                    { required: true, message:'确认密码不能为空', trigger: 'blur'},
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ]
            }
            
        }
    },
    created(){
        if(this.$route.query.userForm){
            let temp = JSON.parse(this.$route.query.userForm)
            this.userForm.id = temp.id
            this.userForm.email = temp.email
        }
    },
    methods:{
        confirmAdd(formName){
            let that = this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                   if(that.userForm.password == that.userForm.confirmPass){
                       let data = {
                           id: that.userForm.id,
                           password: that.userForm.password
                       }
                       that.updatePass(data)
                   }else{
                       that.showToast({
                           h:that,
                           icon:'el-icon-warning',
                           text: '确认密码和新密码不一致'
                       })
                   }
                } else {
                  // eslint-disable-next-line
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        updatePass(data){
            let that = this
          // eslint-disable-next-line
            updatePassword(data).then(res=>{
                that.showToast({
                    h:that
                })
                setTimeout(()=>{
                    that.$router.back()
                },1500)
            })
        }
    }
}
</script>

<style>
.content{
    background: #fff;
    padding: 24px 30px 0 30px;
}
</style>